module.exports = ".exceed_warning{\n    color: #FC0404;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/content/jobs/job-description/job-detail/job-detail.component.css
// module id = ./src/app/main/content/jobs/job-description/job-detail/job-detail.component.css
// module chunks = main